<template>
  <div>
    <div v-for="(item, index) in secondary" :key="index" class="mb-1">
      <a :href="item.secondary_ams_link" target="_blank" v-if="item.secondary_ams_name">
        <span class="regular-16 ams-color"> {{item.secondary_ams_name}}</span><span v-if="index < secondary.length - 1" class="typo-color-black">,</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecondaryMSCSection',
  props: ['secondary'],
}
</script>
